import { MessageBucket, MessagesAction, MessagesState } from '@/types/message';

export const initialBucket: MessageBucket = {
  status: 'idle',
  data: [],
  error: null,
  statusTrail: [],
};

const reducer = (state: MessagesState, action: MessagesAction): MessagesState => {
  const base = state[action.key] ?? initialBucket;
  switch (action.type) {
    case 'start':
      return {
        ...state,
        [action.key]: {
          ...base,
          status: 'loading',
          error: null,
        },
      };
    case 'success':
      return {
        ...state,
        [action.key]: {
          status: 'success',
          data: action.data,
          error: null,
          statusTrail: action.statusTrail ?? base.statusTrail ?? [],
        },
      };
    case 'error':
      return {
        ...state,
        [action.key]: {
          status: 'error',
          data: [],
          error: action.error,
          statusTrail: base.statusTrail ?? [],
        },
      };
    case 'disconnect':
      return {
        ...state,
        [action.key]: {
          ...base,
          status: 'error',
        },
      };
    case 'set':
      return {
        ...state,
        [action.key]: {
          status: 'success',
          data: action.data,
          error: null,
          statusTrail: action.statusTrail ?? base.statusTrail ?? [],
        },
      };
    case 'clear': {
      if (!(action.key in state)) return state;
      const next = { ...state };
      delete next[action.key];
      return next;
    }
    default:
      return state;
  }
};

export default reducer;
